import { render, staticRenderFns } from "./CrossSellingHold.vue?vue&type=template&id=20efa686&"
import script from "./CrossSellingHold.vue?vue&type=script&lang=js&"
export * from "./CrossSellingHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports